import React, { useRef, useEffect } from "react";
import * as d3 from "d3";

const CustomBarChart = ({ data, customHeight, customWidth }) => {
  const svgRef = useRef(null);

  useEffect(() => {
    const svg = d3.select(svgRef.current);
    const width = customWidth; // Adjust as needed
    const height = customHeight; // Adjust as needed
    const margin = { top: 40, right: 0, bottom: 20, left: 30 }; // Adjust as needed
    const safeData = Array.isArray(data) ? data : [];

    svg.selectAll("*").remove();

    svg.attr("width", width).attr("height", height);

    const xScale = d3
      .scaleBand()
      .domain(safeData.map((d) => d.label))
      .range([margin.left, width - margin.right])
      .padding(0.7);
    const maxValue = d3.max(safeData, (d) => Number(d.value) || 0) || 0;
    const yTicks = maxValue > 0 ? undefined : [0];
    const yScale = d3
      .scaleLinear()
      .domain([0, Math.max(maxValue, 1)])
      .nice()
      .range([height - margin.bottom, margin.top]);

    const xAxis = svg
      .append("g")
      .attr("transform", `translate(0,${height - margin.bottom})`)
      .call(d3.axisBottom(xScale));

    const yAxis = svg
      .append("g")
      .attr("transform", `translate(${margin.left},0)`)
      .call(
        d3
          .axisLeft(yScale)
          .tickValues(yTicks)
          .tickFormat(d3.format(".1s")) // Format tick values as "1k", "5k", etc.
      );

    // Style to remove axis lines
    xAxis.select(".domain").remove(); // Remove x-axis line
    yAxis.select(".domain").remove(); // Remove y-axis line

    xAxis.selectAll(".tick line").remove(); // Remove x-axis tick lines
    yAxis.selectAll(".tick line").remove(); // Remove y-axis tick lines

    xAxis.selectAll("text").style("fill", "#979592");
    yAxis.selectAll("text").style("fill", "#979592");

    // Add horizontal grid lines

    const gridGroup = svg.append("g");
    const ticksForGrid = yTicks || yScale.ticks(5);
    ticksForGrid.forEach((tick) => {
      gridGroup
        .append("line")
        .attr("x1", margin.left)
        .attr("x2", width - margin.right)
        .attr("y1", yScale(tick))
        .attr("y2", yScale(tick))
        .attr("stroke", "#363638")
        .attr("stroke-opacity", 0.5);
    });
    svg
      .selectAll("rect")
      .data(safeData)
      .enter()
      .append("rect")
      .attr("x", (d) => xScale(d.label))
      .attr("y", (d) => yScale(Number(d.value) || 0))
      .attr("width", xScale.bandwidth())
      .attr("height", (d) => yScale(0) - yScale(Number(d.value) || 0))
      .attr("fill", "#EFBC51")
      .append("title")
      .text((d) => `${d.label}: ${d.value}`);
  }, [customHeight, customWidth, data]);

  return <svg className="h-fit" ref={svgRef}></svg>;
};

export default CustomBarChart;
